/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {shake as ɵa} from './lib/animations/index';